import Settings from '../olr-common/Settings';

export default function ServiceStubs(parent) {
  if (!Settings.useServiceStubs) return;

  var mockOptions = {
    delay: 0
  };

  parent.requires.push('ngMockE2E');
  parent.config(configStubs);
  parent.run(initStubs);

  function configStubs($httpProvider) {
    $httpProvider.interceptors.push(function($q, $timeout, $log) {
      return {
        "request": function(config) {
          return config;
        },
        "response": function(response) {
          var deferred = $q.defer();

          // Return immediately for non-JSON URLs
          if (response.config.url.indexOf(".json") === -1 || mockOptions.delay === 0) {
            return response;
          }

          // Add optional delay to API URLs
          $log.log("Delaying response with " + mockOptions.delay + "ms");
          $timeout(function() {
            deferred.resolve(response);
          }, mockOptions.delay);

          return deferred.promise;
        }
      };
    });
  }

  function initStubs($httpBackend) {
    $httpBackend.whenGET   (/.*/).passThrough();
    $httpBackend.whenPOST  (/.*/).passThrough();
    $httpBackend.whenPUT   (/.*/).passThrough();
    $httpBackend.whenDELETE(/.*/).passThrough();
  }
}




/** WEBPACK FOOTER **
 ** ./src/olr-servicestubs/index.js
 **/